import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Modal, Paragraph, Popover } from '@treams/treams-ui';

export default function SSODeleteModal({
	visible,
	identityProviderID,
	onCancel,
	onDeleted,
}: {
	visible: boolean;
	identityProviderID: string;
	onCancel: () => void;
	onDeleted: () => void;
}) {
	const { t } = useTranslation();
	const [deleteProvider, { loading, error }] = graphql.useDeleteIdentityProviderMutation();

	const onDeleteClick = async () => {
		try {
			const result = await deleteProvider({
				variables: {
					input: {
						identityProviderID: identityProviderID,
					},
				},
			});

			if (result.data?.deleteIdentityProvider.success) {
				onDeleted();
			}
		} catch {
			// deleteProvider call throws error but also leaves an error state.
			// We ignore the thrown error and use the error state.
		}
	};

	return (
		<Popover center={true} visible={!!(visible && identityProviderID)} onDismiss={onCancel}>
			<Modal>
				<Modal.Header
					title={t('settings.integrations.sso.delete.confirmation.title')}
					onClose={onCancel}
				/>
				<Modal.Contents>
					<Paragraph mb={3}>
						{t('settings.integrations.sso.delete.confirmation.effectexplainer')}
					</Paragraph>
					<Paragraph>{t('settings.integrations.sso.delete.confirmation.body')}</Paragraph>
					{error && <GraphQLErrorMessage error={error.graphQLErrors[0]} />}
				</Modal.Contents>
				<Modal.Footer>
					<Button
						disabled={loading}
						title={t('common.cancel')}
						type={'secondary'}
						onClick={onCancel}
					/>
					<Button
						loading={loading}
						ml={2}
						title={t('common.delete')}
						type={'destructive'}
						disableSuccess={true}
						onClick={onDeleteClick}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
